import {
    Modal,
    ModalActions as ModalActionsE,
    ModalContent,
    ModalHeader as ModalHeaderE,
    ModalProps,
} from "../../../ui_components/modal";
import React from "react";
import styled, { css } from "styled-components";
import { breakpoints, theme } from "../../../theme";
import Button from "../../../ui_components/button/button";

const noop = () => {
    /* ignore */
};

export interface FilterModalProps
    extends Pick<
        ModalProps,
        | "uiActive"
        | "uiOnRequestClose"
        | "className"
        | "uiOnClose"
        | "uiTransitionTimeout"
        | "uiCloseOnEsc"
        | "uiCloseOnOutsideClick"
    > {
    /**
     * Modal header
     */
    uiHeader?: string;
    /**
     * Close modal when pressing Esc
     * @default true
     */
    uiCloseOnEsc?: boolean;
    /**
     * Close modal on outside click
     * @default true
     */
    uiCloseOnOutsideClick?: boolean;
    /**
     * Class name
     */
    className?: string;
    /**
     * Child
     */
    children?: React.ReactChild | Element[] | JSX.Element[];
    /**
     * Confirmation callback
     */
    uiOnConfirm(res?: unknown): void;
    uiOnCloseFilter(res?: unknown): void;
}

const ConfirmationContent = styled(ModalContent)`
    color: ${theme.colors.grayRGBA} !important;
`;

const StyledModal = styled(Modal)`
    max-width: 500px !important;
    width: 100% !important;
    border-radius: 0.5rem !important;
    border: solid ${theme.colors.grayRGBA} 1px !important;
    ${breakpoints.down(
        "sm",
        css`
            max-width: 90% !important;
        `
    )};
`;

const ModalHeader = styled(ModalHeaderE)`
    color: ${theme.colors.primary} !important;
    border-bottom: none !important;
    padding-bottom: 0.25rem !important;
    font-family: "Poppins" !important;
`;

const ModalHeaderDivider = styled.div`
    height: 10px !important;
    width: calc(100% - 40px) !important;
    margin: 0 auto !important;
    background: ${theme.colors.divider} !important;
`;

const ModalActions = styled(ModalActionsE)`
    border-bottom-left-radius: 0.5rem !important;
    border-bottom-right-radius: 0.5rem !important;
    justify-content: space-between !important;
    padding: 0.7rem 1rem !important;
`;

const BasicButton = styled(Button)`
    // width: 130px;
    // box-shadow: none !important;
    // border: 1px solid #c6c6c6 !important;
    // border-radius: 0.5em !important;
    // display: block !important;
`;

const ConfirmButton = styled(BasicButton)`
`;
export const CancelButton = styled(BasicButton)`
    box-shadow: none !important;
`;
/**
 * Simple confirmation modal
 */
export const FilterModal: React.FC<FilterModalProps> = (props) => {
    return (
        <StyledModal
            className={props.className}
            uiActive={props.uiActive}
            uiOnRequestClose={noop}
            uiDefaultSizes={false}
            uiOnClose={props.uiOnClose}
            uiTransitionTimeout={props.uiTransitionTimeout}
            uiCloseOnOutsideClick={props.uiCloseOnOutsideClick}
            uiCloseOnEsc={props.uiCloseOnEsc}
        >
            <ModalHeader>{props.uiHeader}</ModalHeader>
            <ModalHeaderDivider />
            <ConfirmationContent>{props.children}</ConfirmationContent>
            <ModalActions>
                <CancelButton
                    className="cancel_btn"
                    id="cancel"
                    uiColor="primary"
                    onClick={props.uiOnCloseFilter}
                >
                    Cancel
                </CancelButton>
                <ConfirmButton
                    className="primary_btn"
                    id="confirm"
                    uiColor="primary"
                    onClick={props.uiOnConfirm}
                >
                    Apply
                </ConfirmButton>
            </ModalActions>
        </StyledModal>
    );
};

FilterModal.defaultProps = {
    uiHeader: "Filter My Shop",
};
